import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { createPunctualReturnController } from "../lib/punctualReturn";

export default function usePunctualReturn({ enabled, lesson, navigationContext, onReturn, onArrival }) {
  const current = useRef(null);
  current.current = { enabled, lesson, navigationContext, onReturn, onArrival };
  const controller = useRef(null);
  const [error, setError] = useState("");
  const active = enabled && navigationContext?.active === true;
  useEffect(() => {
    setError("");
    if (!active || !lesson?.id || !lesson?.started_at) return undefined;
    const stillActive = () => current.current.enabled && current.current.navigationContext?.active === true
      && current.current.lesson?.id === lesson.id && current.current.lesson?.started_at === lesson.started_at;
    const instance = createPunctualReturnController({
      lessonId: lesson.id, startedAt: lesson.started_at,
      request: async (location, signal) => (await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/work-mode/lessons/${lesson.id}/return-check`,
        location, { withCredentials: true, timeout: 22000, signal },
      )).data,
      onReturn: data => { if (stillActive()) current.current.onReturn(data); },
      onArrival: () => { if (stillActive()) current.current.onArrival(); },
      onError: setError,
    });
    controller.current = instance;
    const tick = () => instance.tick(current.current.navigationContext?.device, current.current.lesson?.active_route_plan);
    tick();
    const timer = window.setInterval(tick, 1000);
    return () => { instance.cancel(); window.clearInterval(timer); controller.current = null; };
  }, [active, lesson?.id, lesson?.started_at]);
  useEffect(() => {
    controller.current?.tick(navigationContext?.device, lesson?.active_route_plan);
  }, [navigationContext?.device, lesson?.active_route_plan]);
  return error;
}
